// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"Autocomplete_itemContainer__2FcQ4","menu":"Autocomplete_menu__16qpv","curtain":"Autocomplete_curtain__3HdY3"};